/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One Fishial candidate species. `name` is a scientific binomial (the model
 * ships no common names); `score` is a cosine similarity in [0, 1], NOT a
 * calibrated probability — the classifier is open-set-blind and always returns
 * a ranked top-k, so the scores themselves convey the (un)certainty.
 * @export
 * @interface SpeciesPrediction
 */
export interface SpeciesPrediction {
    [key: string]: any | any;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    speciesId: string;
    /**
     * 
     */
    score: number;
}

/**
 * Check if a given object implements the SpeciesPrediction interface.
 */
export function instanceOfSpeciesPrediction(value: object): value is SpeciesPrediction {
    if (!('name' in value) || value['name'] === undefined) return false;
    if ((!('speciesId' in (value as Record<string, any>)) && !('species_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['speciesId'] === undefined && (value as Record<string, any>)['species_id'] === undefined)) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    return true;
}

export function SpeciesPredictionFromJSON(json: any): SpeciesPrediction {
    return SpeciesPredictionFromJSONTyped(json, false);
}

export function SpeciesPredictionFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpeciesPrediction {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'name': json['name'],
        'speciesId': json['species_id'],
        'score': json['score'],
    };
}

export function SpeciesPredictionToJSON(json: any): SpeciesPrediction {
    return SpeciesPredictionToJSONTyped(json, false);
}

export function SpeciesPredictionToJSONTyped(value?: SpeciesPrediction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'name': value['name'],
        'species_id': value['speciesId'],
        'score': value['score'],
    };
}

